let Brandfocus_data3 =[
    {
        id : 48,
        imgurl : 'img/section5/section5_3_1.jpg'
    },
    {
        id : 49,
        imgurl : 'img/section5/section5_3_2.jpg'
    },
]

export default Brandfocus_data3;